module.exports = __webpack_public_path__ + "d94e20c1/img/chevron-down-icon.5542f65c.svg";